<template>
  <div class="list">
    <div class="img-con">
      <img class="img" :src="item.filePath[0]+'?imageView2/0/w/200/h/150'" alt="">
      <div class="is-boutique" v-if="false"></div>
      <div class="is-vip-shop" v-if="item.isVipShop"></div>
      <div class="is-member-bag" v-if="item.isMemberBag"></div>
    </div>
    <div class="text-con">
      <div class="list-title"><span class="type">{{ knowledgeTypeName(item.products[0].courseType) }}</span>{{ item.products[0].productTitle }}</div>
      <div class="price-con">
        <span class="price">{{ item.products[0].sellPrice===0?'免费':('￥'+item.products[0].sellPrice) }}</span>
      </div>
      <div class="sub-text">
        <span class="num" v-if="item.products[0].courseType===null">已更新{{ item.products[0].currentCourseCount }}期</span>
        <span class="num" v-if="item.products[0].courseType===null && item.products[0].planCourseCount">共{{ item.products[0].planCourseCount }}期</span>

        <span class="num" v-if="item.products[0].courseType!==null">时长:{{ formatSeconds(item.products[0].courseType, item.products[0].duration) }}</span>
        <span class="num">收藏:{{ item.products[0].collectUserCount }}</span>
        <span class="num">已报名:{{ item.products[0].salesVolume }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data(){
    return{

    }
  },
  created(){
    // console.log( this.item )
  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.list{
  height: 102px;
  padding: 12px;
  display: flex;
  box-shadow: 0 1px 0 0 #edecec;
  .img-con{
    width: 100px;
    height: 75px;
    position: relative;
    .img{
      display: block;
      width: 100px;
      height: 75px;
    }
    .is-boutique{
      position: absolute;z-index: 0;top: 0;left: 0;
      width: 25px;height: 15px;
      background: url("../../../../assets/mall/goods-icon-boutique.png") no-repeat 50% 50%;
      background-size: 100%;
    }
    .is-vip-shop{
      position: absolute;z-index: 0;top: -9px;right: -4px;
      /*width: 26px;height: 19px;*/
      width: 23.4px;height: 17.1px;
      background: url("../../../../assets/mall/goods-icon-vip.png") no-repeat 50% 50%;
      background-size: 100%;
    }
    .is-member-bag{
      position: absolute;z-index: 0;bottom: -14px;right: -4px;
      /*width: 32px;height: 39px;*/
      width: 28.8px;height: 35.1px;
      background: url("../../../../assets/mall/goods-icon-member-bag.png") no-repeat 50% 50%;
      background-size: 90%;
    }
  }
  .text-con{
    flex: 1;
    padding-left: 10px;
    .list-title{
      margin: 4px 0 4px;
      font-size: 14px;
      padding: 2px;
      color: #2b2b2b;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .type{
        margin: 0 5px 0 0;
        font-size: 9px;
        border: .75px solid #1585f3;
        color: #1585f3;
        border-radius: 2px;
        padding: 1px 2.5px;
      }
    }
    .price-con{
      .price{
        font-size: 14px;color: #f74d4d;
      }
    }
    .sub-text{
      font-size: 9px;
      color: #999;
      .num{
        padding-right: 6px;
      }
      .price{
        font-size: 14px;
        color: #f34b4b;
        float: right;
      }
    }
  }
}
</style>